'use strict';

angular.module('selfAccessRequestSharedControllers')

.controller('SelectSameAsController', ['$scope', 'searchService', function ($scope, searchService) {

    $scope.ctxtSelectSameAsEmp = {};

    // Search Employees
    $scope.searchEmployees = function () {
        var searchTerm = $scope.ctxtSelectSameAsEmp.searchTerm;
        $scope.resetDecisionContainer();

        if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
            $scope.availableSameAsEmployees = [];
            return;
        }

        searchService
            .searchActiveEmployees(searchTerm)
            .then(function (foundEmployees) {
                $scope.availableSameAsEmployees = foundEmployees;
            });
    };

    // Select SameAs Employee
    $scope.selectSameAsEmployee = function (emp) {
        $scope.newSameAsEmployee(emp)
              .then(function (decisionContainer) {
                  $scope.ctxtSelectSameAsEmp.decisionContainer = decisionContainer;
              });
    };

    // Reset Decision Container
    $scope.resetDecisionContainer = function () {
        $scope.ctxtSelectSameAsEmp.decisionContainer = null;
    };

}]);